import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER,NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StartPageComponent } from './___COMPONENTS/___Pages/start-page/start-page.component';
import { ClientCardsComponent } from './___COMPONENTS/___Pages/client-cards/client-cards.component';

// Http
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

// Hash location 
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

//Forms
import { FormsModule } from '@angular/forms'; // Import FormsModule

// MATERIAL
//MATERIAL
// Card
import {MatCard, MatCardModule} from '@angular/material/card';
//DIVIDER
import {MatDividerModule} from '@angular/material/divider';
// List
import {MatListModule} from '@angular/material/list';
// ICON
import {MatIconModule} from '@angular/material/icon';
// CHIPS
import {MatChipsModule} from '@angular/material/chips';
// TABS
import {MatTabsModule} from '@angular/material/tabs';
// BUTTON
import {MatButtonModule} from '@angular/material/button';
// BUTTON TOGGLE
import {MatButtonToggleModule} from '@angular/material/button-toggle';
// Mat Checkbox
import { MatCheckboxModule } from '@angular/material/checkbox';
// INPUt
import {MatInputModule} from '@angular/material/input';
// Progress Bar
import {MatProgressBarModule} from '@angular/material/progress-bar';
// Tooltip
import {MatTooltipModule} from '@angular/material/tooltip';
//SnackBar
import {MatSnackBarModule} from '@angular/material/snack-bar';
// Toolbar
import {MatToolbarModule} from '@angular/material/toolbar';
// MatBadge
import {MatBadgeModule} from '@angular/material/badge';
// MatDialog Module
import { MatDialogModule } from '@angular/material/dialog';
// Slide Toggle
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// Mat Drawer
import { MatSidenavModule } from '@angular/material/sidenav';
// Mat Table
import { MatTableModule } from '@angular/material/table';
// Drag Drop
import { DragDropModule } from '@angular/cdk/drag-drop';
// Paginator
import {MatPaginatorModule} from '@angular/material/paginator';
// Mate Menu Module
import {MatMenuModule} from '@angular/material/menu';
// Expansion Panel
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
// Form Field
import {MatFormFieldModule} from '@angular/material/form-field';
// Forms like login
import { ReactiveFormsModule } from '@angular/forms'; // Import this module


// DATE PICKER
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';

// MatStep
import {MatStepperModule} from '@angular/material/stepper';

// Bottom sheet
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

// SERVICES
import { AppInitService } from './___LOGIC/__init/app-init.service';


import { ClientInteractionsComponent } from './___COMPONENTS/__crmTools/client-interactions/client-interactions.component';
import { SmartTextComponent } from './___COMPONENTS/__common/smart-text/smart-text.component';
import { FirstContactFormComponent } from './___COMPONENTS/first-contact-form/first-contact-form.component';
import { EmailInputComponent } from './___COMPONENTS/__common/email-input/email-input.component';
import { ClientProfileComponent } from './___COMPONENTS/___Pages/client-profile/client-profile.component';
import { ClientBoardComponent } from './___COMPONENTS/client-board/client-board.component';
import { CardsBoardComponent } from './___COMPONENTS/cards-board/cards-board.component';
import { DateRenderComponent } from './___COMPONENTS/__common/date-render/date-render.component';
import { SmartParagraphComponent } from './___COMPONENTS/__common/smart-paragraph/smart-paragraph.component';
import { BottomModalComponent } from './___COMPONENTS/__common/bottom-modal/bottom-modal.component';
import { SpinnerModalComponent } from './___COMPONENTS/__common/spinner-modal/spinner-modal.component';
import { EmailComposerComponent } from './___COMPONENTS/__crmTools/email-composer/email-composer.component';
import { EmailPreviewComponent } from './___COMPONENTS/__crmTools/email-preview/email-preview.component';
import { HomeComponent } from './___COMPONENTS/___Pages/home/home.component';
import { WebappUserConfigComponent } from './___COMPONENTS/webapp-user-config/webapp-user-config.component';
import { CrudComponent } from './___COMPONENTS/__crud/crud/crud.component';
import { DynamicCrudFormComponent } from './___COMPONENTS/__crud/dynamic-crud-form/dynamic-crud-form.component';
import { DynamicInputComponent } from './___COMPONENTS/__crud/dynamic-input/dynamic-input.component';
import { DynamicDatePickerComponent } from './___COMPONENTS/__crud/dynamic-date-picker/dynamic-date-picker.component';
import { DynamicTextareaComponent } from './___COMPONENTS/__crud/dynamic-textarea/dynamic-textarea.component';
import { DynamicCrudSelectComponent } from './___COMPONENTS/__crud/dynamic-crud-select/dynamic-crud-select.component';
import { DynamicTimestampPickerComponent } from './___COMPONENTS/__crud/dynamic-timestamp-picker/dynamic-timestamp-picker.component';
import { BachLegalClientsComponent } from './___COMPONENTS/__collabs/bach-legal-clients/bach-legal-clients.component';
import { OmnibusClientsComponent } from './___COMPONENTS/__collabs/omnibus-clients/omnibus-clients.component';
import { SmartSelectComponent } from './___COMPONENTS/__common/smart-select/smart-select.component';
import { BudgetsComponent } from './___COMPONENTS/__crmTools/__budgets/budgets/budgets.component';
import { PackageBuilderComponent } from './___COMPONENTS/__crmTools/__budgets/package-builder/package-builder.component';
import { ShopifyOrdersComponent } from './___COMPONENTS/__shopify/shopify-orders/shopify-orders.component';
import { LoginPageComponent } from './___COMPONENTS/___Pages/login-page/login-page.component';
import { VisaPipelineComponent } from './___COMPONENTS/__subapps/visa-pipeline/visa-pipeline.component';
import { TaskDetailsComponent } from './___COMPONENTS/task-details/task-details.component';
import { SmartTooltipComponent } from './___COMPONENTS/__common/smart-tooltip/smart-tooltip.component';
import { SupermarketHelperComponent } from './___COMPONENTS/supermarket-helper/supermarket-helper.component';
import { BudgetBuilderComponent } from './___COMPONENTS/__crmTools/__budgets/budget-builder/budget-builder.component';
import { DatePickerComponent } from './___COMPONENTS/__common/date-picker/date-picker.component';
import { ClientManagerComponent } from './___COMPONENTS/__crmTools/client-manager/client-manager.component';
import { StudyHelperComponent } from './___COMPONENTS/study-helper/study-helper.component';
import { StudyOptionsComponent } from './___COMPONENTS/study-options/study-options.component';
import { StudyCenterDetailsComponent } from './___COMPONENTS/study-center-details/study-center-details.component';
import { PricingPlansComponent } from './___COMPONENTS/pricing-plans/pricing-plans.component';
import { RequirementListComponent } from './___COMPONENTS/requirement-list/requirement-list.component';
import { RequirementDetailComponent } from './___COMPONENTS/requirement-detail/requirement-detail.component';
import { ClientProcessComponent } from './___COMPONENTS/client-process/client-process.component';
import { ShopifySimulatorComponent } from './___COMPONENTS/__shopify/shopify-simulator/shopify-simulator.component';
import { SmartToggleComponent } from './___COMPONENTS/__common/smart-toggle/smart-toggle.component';
import { WebappManagerComponent } from './___COMPONENTS/__crmTools/webapp-manager/webapp-manager.component';
import { FileUploadComponent } from './___COMPONENTS/__common/file-upload/file-upload.component';
import { LogViewerComponent } from './___COMPONENTS/__common/log-viewer/log-viewer.component';
import { FileManagerComponent } from './___COMPONENTS/__crmTools/file-manager/file-manager.component';
import { FilePreviewDialogComponent } from './___COMPONENTS/file-preview-dialog/file-preview-dialog.component';
import { EditContractModalComponent } from './___COMPONENTS/edit-contract-modal/edit-contract-modal.component';
import { DynamicCrudComponent } from './___COMPONENTS/dynamic-crud/dynamic-crud.component';
import { DynamicSlideToggleComponent } from './___COMPONENTS/dynamic-slide-toggle/dynamic-slide-toggle.component';
import { DynamicCrudFieldComponent } from './___COMPONENTS/dynamic-crud-field/dynamic-crud-field.component';
import { DynamicItemDirective } from './___LOGIC/__directives/dynamic-item.directive';
import { CrudDynamicComponent } from './___COMPONENTS/crud-dynamic/crud-dynamic.component';
import { RouterModule } from '@angular/router';
import { PackDetailsModalComponent } from './___COMPONENTS/pack-details-modal/pack-details-modal.component';
import { CalendlyManagerComponent } from './___COMPONENTS/calendly-manager/calendly-manager.component';
import { SliderHorizontalComponent } from './___COMPONENTS/__common/slider-horizontal/slider-horizontal.component';
import { SettingsPageComponent } from './___COMPONENTS/settings-page/settings-page.component';
import { HttpErrorInterceptor } from './___LOGIC/http/http-error.interceptor';
import { CustomSnackbarComponent } from './___COMPONENTS/custom-snackbar/custom-snackbar.component';
import { CredentialsInterceptor } from './___core/interceptors/credentials.interceptor';
import { AuthInterceptor } from './___core/interceptors/auth.interceptor';
import { SafeUrlPipe } from './___LOGIC/__common/safe-url.pipe';
import { ClientActivatedToolsComponent } from './___COMPONENTS/client-activated-tools/client-activated-tools.component';


export function initializeApp(appInitService: AppInitService) {
  return (): Promise<any> => { 
    return appInitService.load();
  }
}

@NgModule({
  declarations: [
    AppComponent,
    StartPageComponent,
    ClientCardsComponent,
    ClientInteractionsComponent,
    BudgetsComponent,
    SmartTextComponent,
    FirstContactFormComponent,
    EmailInputComponent,
    ClientProfileComponent,
    ClientBoardComponent,
    CardsBoardComponent,
    DateRenderComponent,
    SmartParagraphComponent,
    BottomModalComponent,
    EmailPreviewComponent,
    PackageBuilderComponent,
    SmartSelectComponent,
    SpinnerModalComponent,
    EmailComposerComponent,
    HomeComponent,
    WebappUserConfigComponent,
    OmnibusClientsComponent,
    BachLegalClientsComponent,
    ShopifyOrdersComponent,
    CrudComponent,
    DynamicCrudFormComponent,
    DynamicInputComponent,
    DynamicDatePickerComponent,
    DynamicTextareaComponent,
    DynamicCrudSelectComponent,
    DynamicTimestampPickerComponent,
    LoginPageComponent,
    VisaPipelineComponent,
    TaskDetailsComponent,
    SmartTooltipComponent,
    SupermarketHelperComponent,
    BudgetBuilderComponent,
    DatePickerComponent,
    ClientManagerComponent,
    StudyHelperComponent,
    StudyOptionsComponent,
    StudyCenterDetailsComponent,
    PricingPlansComponent,
    RequirementListComponent,
    RequirementDetailComponent,
    ClientProcessComponent,
    ShopifySimulatorComponent,
    ClientActivatedToolsComponent,
    SmartToggleComponent,
    LogViewerComponent,
    WebappManagerComponent,
    FileUploadComponent,
    FileManagerComponent,
    FilePreviewDialogComponent,
    SafeUrlPipe,
    EditContractModalComponent,
    DynamicCrudComponent,
    DynamicSlideToggleComponent,
    DynamicCrudFieldComponent,
    DynamicItemDirective,
    CrudDynamicComponent,
    PackDetailsModalComponent,
    CalendlyManagerComponent,
    SliderHorizontalComponent,
    SettingsPageComponent,
    CustomSnackbarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    //
    // Http
    HttpClientModule,
    //Forms
    FormsModule,
    // MATERIAL
    MatCardModule,
    // Button
    MatButtonModule,
    //MatButtonToggleModule
    MatButtonToggleModule,
    //Card
    MatCardModule,
    //Expansion
    MatExpansionModule,
    //Toolbar
    MatToolbarModule,
    //Mat Checkbox
    MatCheckboxModule,
    // MatBadgeModule
    MatBadgeModule,
    // Mat Table
    MatTableModule,
    // Spinner
    MatProgressSpinnerModule,
    // Divider
    MatDividerModule,
    // List
    MatListModule,
    // ICON
    MatIconModule,
    //Mat menu module
    MatMenuModule,
    //SideNav
    MatSidenavModule,
    // Paginator
    MatPaginatorModule,
    // Chips
    MatChipsModule,
    // Tabs
    MatTabsModule,
    // Progress Bar
    MatProgressBarModule,
    // Tooltip
    MatTooltipModule,
    // Snackbar
    MatSnackBarModule,
    // MatStep
    MatStepperModule,
    // Dialog Module
    MatDialogModule,
    //
    MatBottomSheetModule,
    // SLide toggle
    MatSlideToggleModule,
    // Mat Form
    MatFormFieldModule,
    //Input
    MatInputModule,
    // Drag drop
    DragDropModule,
    // Select
    MatSelectModule,
    // Date Picker
    MatDatepickerModule,
    MatNativeDateModule,
    // Reactive Form
    ReactiveFormsModule,
    RouterModule.forChild([{ path: 'crud/:table', component: CrudDynamicComponent }])
  ],
  entryComponents: [TaskDetailsComponent],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
